module.exports = __webpack_public_path__ + "img/demo-health-hub.23908bc6.png";